import { roleChangeRequest } from './constants';
import axios from '../helpers/axios';
import swal from 'sweetalert';

export const createRoleChangeRequest = (payload, userId, officeId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: roleChangeRequest.CREATE_ROLE_CHANGE_REQUEST });

            const res = await axios.post('/roleChangeRequest/create', payload);

            if (res.status === 201) {
                dispatch({
                    type: roleChangeRequest.CREATE_ROLE_CHANGE_SUCCESS,
                    payload: res.data,
                });

                if (userId) {
                    await dispatch(getRoleChangeRequestProfileByUser(userId, officeId));
                }

                swal({
                    title: 'Успешно отправлено',
                    text: 'Заявка на доступ в офис отправлена',
                    icon: 'success',
                });

                return true;
            }

            dispatch({
                type: roleChangeRequest.CREATE_ROLE_CHANGE_FAILURE,
                payload: res.data,
            });

            swal({
                title: 'Ошибка отправки',
                text: res.data?.message || 'Не удалось отправить заявку',
                icon: 'warning',
            });

            return false;
        } catch (error) {
            dispatch({
                type: roleChangeRequest.CREATE_ROLE_CHANGE_FAILURE,
                payload: error?.response?.data || { message: 'Ошибка отправки запроса' },
            });

            swal({
                title: 'Ошибка отправки',
                text: error?.response?.data?.message || 'Ошибка отправки запроса',
                icon: 'error',
            });

            return false;
        }
    };
};

export const getRoleChangeRequestProfileByUser = (userId, officeId) => {
    return async (dispatch) => {
        dispatch({ type: roleChangeRequest.GET_ROLE_CHANGE_BY_USER_REQUEST });

        try {
            const res = await axios.get('/roleChangeRequest/getByUser', {
                params: { userId, officeId },
            });

            if (res.status === 200) {
                dispatch({
                    type: roleChangeRequest.GET_ROLE_CHANGE_BY_USER_SUCCESS,
                    payload: res.data,
                });

                return res.data;
            }

            dispatch({
                type: roleChangeRequest.GET_ROLE_CHANGE_BY_USER_FAILURE,
                payload: res.data,
            });

            return null;
        } catch (error) {
            dispatch({
                type: roleChangeRequest.GET_ROLE_CHANGE_BY_USER_FAILURE,
                payload: error?.response?.data || { message: 'Ошибка загрузки заявок' },
            });

            return null;
        }
    };
};

export const getOfficeRoleChangeRequests = (officeId, sort = 'updatedAtMinus', sortStatusOrder = 'all') => {
    return async (dispatch) => {
        dispatch({ type: roleChangeRequest.GET_OFFICE_ROLE_CHANGE_REQUESTS_REQUEST });

        try {
            const res = await axios.get('/roleChangeRequest/get', {
                params: { officeId, sort, sortStatusOrder },
            });

            if (res.status === 200) {
                dispatch({
                    type: roleChangeRequest.GET_OFFICE_ROLE_CHANGE_REQUESTS_SUCCESS,
                    payload: res.data,
                });
                return res.data;
            }

            dispatch({
                type: roleChangeRequest.GET_OFFICE_ROLE_CHANGE_REQUESTS_FAILURE,
                payload: res.data,
            });

            return null;
        } catch (error) {
            dispatch({
                type: roleChangeRequest.GET_OFFICE_ROLE_CHANGE_REQUESTS_FAILURE,
                payload: error?.response?.data || { message: 'Ошибка загрузки заявок офиса' },
            });
            return null;
        }
    };
};

export const updateRoleChangeRequestStatus = ({ applicationId, type, officeId }) => {
    return async (dispatch) => {
        dispatch({ type: roleChangeRequest.UPDATE_ROLE_CHANGE_STATUS_REQUEST });

        try {
            const res = await axios.post('/roleChangeRequest/updateStatus', {
                applicationId,
                type,
            });

            if (res.status === 201) {
                dispatch({
                    type: roleChangeRequest.UPDATE_ROLE_CHANGE_STATUS_SUCCESS,
                    payload: res.data,
                });

                if (officeId) {
                    await dispatch(getOfficeRoleChangeRequests(officeId));
                }

                return true;
            }

            dispatch({
                type: roleChangeRequest.UPDATE_ROLE_CHANGE_STATUS_FAILURE,
                payload: res.data,
            });

            return false;
        } catch (error) {
            dispatch({
                type: roleChangeRequest.UPDATE_ROLE_CHANGE_STATUS_FAILURE,
                payload: error?.response?.data || { message: 'Ошибка обновления статуса' },
            });
            return false;
        }
    };
};

export const updateRoleChangeRequestViewed = (id, officeId) => {
    return async (dispatch) => {
        dispatch({ type: roleChangeRequest.UPDATE_ROLE_CHANGE_VIEWED_REQUEST });

        try {
            const res = await axios.put(`/roleChangeRequest/${id}/viewed`);

            if (res.status === 200) {
                dispatch({
                    type: roleChangeRequest.UPDATE_ROLE_CHANGE_VIEWED_SUCCESS,
                    payload: res.data,
                });

                if (officeId) {
                    await dispatch(getOfficeRoleChangeRequests(officeId));
                }

                return true;
            }

            dispatch({
                type: roleChangeRequest.UPDATE_ROLE_CHANGE_VIEWED_FAILURE,
                payload: res.data,
            });

            return false;
        } catch (error) {
            dispatch({
                type: roleChangeRequest.UPDATE_ROLE_CHANGE_VIEWED_FAILURE,
                payload: error?.response?.data || { message: 'Ошибка отметки просмотра' },
            });
            return false;
        }
    };
};

export const deleteRoleChangeRequestById = (id, officeId) => {
    return async (dispatch) => {
        dispatch({ type: roleChangeRequest.DELETE_ROLE_CHANGE_REQUEST });

        try {
            const res = await axios.delete(`/roleChangeRequest/delete/${id}`);

            if (res.status === 200) {
                dispatch({
                    type: roleChangeRequest.DELETE_ROLE_CHANGE_SUCCESS,
                    payload: res.data,
                });

                if (officeId) {
                    await dispatch(getOfficeRoleChangeRequests(officeId));
                }

                return true;
            }

            dispatch({
                type: roleChangeRequest.DELETE_ROLE_CHANGE_FAILURE,
                payload: res.data,
            });

            return false;
        } catch (error) {
            dispatch({
                type: roleChangeRequest.DELETE_ROLE_CHANGE_FAILURE,
                payload: error?.response?.data || { message: 'Ошибка удаления заявки' },
            });
            return false;
        }
    };
};